import React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  children: React.ReactNode;
  htmlFor?: string;
  className?: string;
}

/**
 * Label component wrapping Radix UI Label primitive.
 * Provides accessible labels for form inputs with proper focus management.
 *
 * Automatically associates with input elements via htmlFor attribute.
 */
export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ children, className, ...props }, forwardedRef) => {
  return (
    <LabelPrimitive.Root
      ref={forwardedRef}
      className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${
        className || ""
      }`}
      {...props}
    >
      {children}
    </LabelPrimitive.Root>
  );
});

Label.displayName = "Label";

export default Label;
